// ═══ 데스크톱(≥1024) 신청 1페이지 — 우측 sticky 요약 (신고 371 §8 C1) ═══
// 시안 정본 desktop/c1/index.html 의 `.rcol .srail`. 입력값 미리보기 · 첨부 · 검차비 · 안내 · [신청하기].
// 제출은 request/useRequestSubmit.js 의 기존 submitLink/submitPhotosOnly/submitFull 로만 간다(여기엔 로직 0).
import React from 'react';
import { T, R } from '../../../theme';
import SimpleCard from '../../parts/SimpleCard';
import LtrText from '../../parts/LtrText';
import MoneyKRW from '../../parts/MoneyKRW';
import ErrorText from '../../parts/ErrorText';
import { NoteBox, btnNavy, btnDisabled } from './bits';

var DASH = '—';

var body = { padding: '12px 14px', display: 'flex', flexDirection: 'column', gap: 10 };
var kv = { display: 'flex', alignItems: 'baseline', gap: 10, fontSize: 12, minWidth: 0 };
var k = { color: T.faint, fontWeight: 700, flex: 'none', minWidth: 78 };
var v = { color: T.ink, fontWeight: 600, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var vEmpty = { color: T.faint, fontWeight: 400 };
var photoRow = { display: 'flex', alignItems: 'center', gap: 8 };
var photoLab = { fontSize: 11, fontWeight: 700, color: T.faint };
var thumbs = { display: 'flex', gap: 6, marginInlineStart: 'auto', direction: 'ltr' };
var thumb = { width: 40, height: 30, borderRadius: R.sm, overflow: 'clip', border: '1px solid ' + T.bd,
  background: T.head, flex: 'none' };
var thumbImg = { width: '100%', height: '100%', objectFit: 'cover', display: 'block' };
var feeBox = { display: 'flex', alignItems: 'center', gap: 10, padding: '11px 12px', borderRadius: R.md,
  background: T.bandBg, border: '1px solid ' + T.bandBd };
var feeLab = { fontSize: 12, fontWeight: 700, color: T.dim };
var feeVal = { marginInlineStart: 'auto', fontSize: 18, fontWeight: 800, color: T.money, letterSpacing: '-.4px' };
var cta = Object.assign({}, btnNavy, { width: '100%' });

function Row(props) {
  var empty = !props.children;
  return (<div style={kv}>
    <span style={k}>{props.label}</span>
    <span style={empty ? Object.assign({}, v, vEmpty) : v}>{empty ? DASH : props.children}</span>
  </div>);
}

function DesktopSummary(props) {
  var t = props.t;
  var f = props.form;
  var photos = props.photos;
  var span = [f.car_year.trim(), f.car_mileage.trim()].filter(Boolean).join(' · ');
  var firstError = props.errors.model || props.errors.url || props.errors.location || props.errors.photo || '';

  return (<SimpleCard title={t('simpleReqTitle')}>
    <div style={body}>
      {firstError ? <ErrorText>{firstError}</ErrorText> : null}
      <ErrorText>{props.submitError}</ErrorText>

      <Row label={t('evalFormModel')}>{[f.car_model.trim(), f.car_detail.trim()].filter(Boolean).join(' · ')}</Row>
      <Row label={t('evalFormCarNumber')}>{f.car_number.trim() ? <LtrText>{f.car_number.trim()}</LtrText> : ''}</Row>
      <Row label={t('evalFormYear')}>{span ? <LtrText>{span}</LtrText> : ''}</Row>
      {props.listingHost ? <Row label={t('evalFormListingUrl')}><LtrText>{props.listingHost}</LtrText></Row> : null}
      <Row label={t('evalFormLocation')}>{f.location.trim()}</Row>
      <Row label={t('simpleMemoLabel')}>{f.memo.trim()}</Row>

      {photos.length ? (<div style={photoRow}>
        <span style={photoLab}>{t('inspPhotoSection')}</span>
        <span style={thumbs}>
          {photos.map(function (p) {
            return (<span key={p.key} style={thumb} data-testid="sum-thumb">
              {p.url ? <img src={p.url} alt="" style={thumbImg} /> : null}
            </span>);
          })}
        </span>
      </div>) : null}

      <div style={feeBox}>
        <span style={feeLab}>{t('evalFormFee')}</span>
        <MoneyKRW won={props.fee} style={feeVal} />
      </div>
      <NoteBox><div>{t('simpleSchedNote')}</div></NoteBox>

      <button type="button" data-testid="desk-submit" disabled={props.disabled}
        style={props.disabled ? Object.assign({}, cta, btnDisabled) : cta}
        onClick={props.onSubmit}>{t('simpleSubmit')}</button>
    </div>
  </SimpleCard>);
}

export default DesktopSummary;
